import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import isEmpty from "lodash/isEmpty";
import _omit from "lodash/omit";
import NumberFormat from "react-number-format";
import sanitizeHtml from "sanitize-html";

// Components
import Select from "react-select";
import "react-select/dist/react-select.css";
import Loader from "../utils/Loader";
import ImageUploader from "../utils/ImageUploader";

// State
import { addRoute } from "../../store/actions/route";
import { setpageTitle, getSiteInfo } from "../../store/actions/siteInfo";
import { userTokenUpdate } from "../../store/actions/user";
import { getLocations, getProvinces } from "../../store/actions/locations";
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../shared/vars";

// Utils
import { deleteTempImages } from "../../utils/uploadHelpers";

class AdminCartSettings extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			data: {},

			error: "",
			updateLoading: false,
			updateSuccess: "",
			updateErrors: {},
			promiseCollection: []
		};

		this.props.addRoute(this.props.match);
		this.props.setpageTitle("Cart Settings");
	}

	componentDidMount() {
		this.props.getLocations();
		this.loadData();
	}

	loadData() {
		this.setState({
			isLoading: true,
			data: {}
		});

		this.props.getSiteInfo();

		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + this.props.user.token };
		return axios
			.get(REACT_APP_API_URL + "settings", { headers: AUTH_HEADER })
			.then(response => {
				if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
					this.setState({ isLoading: false, error: response.data.message });
				} else {
					// Omit any useless values for the data set
					const dataSet = _omit(response.data, ["merchantTypes", "countries", "provinces", "similar_product_types", "charity"]);
					const initialLogo = !!dataSet.logo ? { img: dataSet.logo } : null;
					const initialNoProductImg = !!dataSet.no_product_img ? { img: dataSet.no_product_img } : null;

					this.setState({
						isLoading: false,
						data: {
							...dataSet
						},
						charity: {
							...response.data.charity
						},
						initialLogo,
						initialNoProductImg,
						shipping: response.data.shipping,
						similar_product_types: response.data.similar_product_types
					});
				}
			})
			.catch(err => {
				if (err.response) {
					this.setState({ isLoading: false, error: err.response.data.errors ? err.response.data.errors : err.response.data.message });
				} else {
					this.setState({ isLoading: false, error: err.message });
				}
			});
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.default_country !== null && this.state.data.country === "") {
			this.setState({
				data: {
					...this.state.data,
					country: nextProps.default_country
				}
			});
		}
	}

	updateSelectedCountry = (country, id) => {
		this.setState(
			{
				data: {
					...this.state.data,
					[id]: country.id,
					province: ""
				}
			},
			() => this.props.getProvinces(this.state.data[id])
		);
	};

	updateSelectedProvince = (province, id) => {
		this.setState({
			data: {
				...this.state.data,
				[id]: province.abbreviation
			}
		});
	};

	handleInputChange(event) {
		const { id, value } = event.target;
		this.setState({
			data: {
				...this.state.data,
				[id]: value
			}
		});
	}

	handleKeyPress(event) {
		if (event.key === "Enter") {
			this.handleSubmit();
		}
	}

	handleNumberChange(id, valueObject) {
		this.setState({
			data: {
				...this.state.data,
				[id]: valueObject.value
			}
		});
	}

	handleShippingChange(country, valueObject) {
		this.setState({
			data: {
				...this.state.data,
				shipping: [
					...this.state.data.shipping.map(shipItem => {
						if (shipItem.id !== country) return shipItem;
						shipItem.cost = valueObject.value;
						return shipItem;
					})
				]
			}
		});
	}

	handleCharityChange(event){
		const { id, value } = event.target;
		this.setState({
			charity: {
				...this.state.charity,
				[id]: value
			}
		});
	}

	handleCharityActive(){
		this.setState({
			charity: {
				...this.state.charity,
				active: this.state.charity.active === 1 ? 0 : 1
			}
		});
	}

	handleRadioClick(event, name) {
		const { value } = event.target;
		this.setState({
			data: {
				...this.state.data,
				[name]: value
			}
		});
	}

	removeExistingImage(propertyName) {
		this.setState({
			data: {
				...this.state.data,
				[propertyName]: ""
			}
		});
	}

	// ===================================================================================
	//  SUBMIT
	// ===================================================================================
	handleSubmit() {
		// Set the state to let everything know that submitting is happening
		// We need to wait for this to actually complete and utilize the callback so any uploaders
		// actually know that they should begin uploading
		this.setState(
			{
				updateSuccess: "",
				updateErrors: {},
				updateLoading: true
			},
			() => {
				// Wait until all uploader promises have completed
				Promise.all(this.state.promiseCollection)
					.then(resolves => {
						// console.log('ok parent:', resolves)

						this.setState({
							promiseCollection: []
						});

						this.completeSubmit(resolves);
					})
					.catch(err => {
						// console.log('err parent:', err)
						this.setState({
							updateLoading: false,
							promiseCollection: []
						});
					});
			}
		);
	}

	completeSubmit(resolves) {
		const { user } = this.props;
		const { data, charity } = this.state;
		let uploadedUrls = [];

		// If there are uploads, grab specific info from them for the new images
		if (!!resolves) {
			resolves.forEach(resolve => {
				if (!resolve) return;
				const upload = resolve[0];
				data[upload.type] = upload.results;

				uploadedUrls.push(upload.results);
			});
		}

		// Add charity to post data
		const postData = {
			...data,
			charity
		}

		const token = user.token;
		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };
		return axios
			.post(REACT_APP_API_URL + "settings/chunked", postData, { headers: AUTH_HEADER })
			.then(response => {
				if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
					this.setState({
						updateLoading: false,
						updateErrors: !isEmpty(response.data.errors) ? response.data.errors : { general: response.data.message }
					});

					deleteTempImages(uploadedUrls, this.props.user.token).catch(err => {
						console.log(err);
					});
				} else {
					this.setState({
						updateLoading: false,
						updateSuccess: response.data.message
					});

					this.props.userTokenUpdate("admin", response.data.token);
					this.loadData();
				}
			})
			.catch(err => {
				if (err.response) {
					this.setState({
						updateLoading: false,
						updateErrors: { general: err.response.data.error ? err.response.data.error : err.response.data.message }
					});
				} else {
					this.setState({
						updateLoading: false,
						updateErrors: { general: err.message }
					});
				}

				deleteTempImages(uploadedUrls, this.props.user.token).catch(err => {
					console.log(err);
				});
			});
	}

	render() {
		const { locationsLoading, locationsError, countries, provinces } = this.props;
		const { error, isLoading, updateLoading, updateErrors, updateSuccess, promiseCollection } = this.state;

		return (
			<div>
				<h1>Cart Settings</h1>

				{/* Has error */}
				{error ? (
					<div className="error">{Object.keys(error).map(key => <span key={key}>{error[key]}</span>)}</div>
				) : // No error
				// Loading
				isLoading ? (
					<div className="pt2 pb2">
						<Loader />
					</div>
				) : (
					// Show form
					<div>
						<div className="tight-form-fields">
							<div className="fieldset">
								<div className="form-field">
									<label>Site Title</label>

									{updateErrors.title && <div className="error msg_animate">{updateErrors.title}</div>}
									<input type="text" id="title" placeholder="Cart Site" value={this.state.data.title} maxLength="255" onKeyPress={e => this.handleKeyPress(e)} onChange={event => this.handleInputChange(event)} />
								</div>

								<div className="form-field">
									<label>Default Address</label>

									{updateErrors.default_email && <div className="error msg_animate">{updateErrors.default_email}</div>}
									<input type="email" id="default_email" placeholder="email@website.com" value={this.state.data.default_email} maxLength="255" onKeyPress={e => this.handleKeyPress(e)} onChange={event => this.handleInputChange(event)} />
								</div>

								<div className="floated-field-container">
									{this.state.data.shipping.map((shipCountry, i) => {
										return (
											<div key={i} className="form-field half-field">
												<label>Default Shipping Cost ({shipCountry.country})</label>

												{updateErrors[`default_shipping_cost_${shipCountry.country}`] && <div className="error msg_animate">{updateErrors[`default_shipping_cost_${shipCountry.country}`]}</div>}

												<NumberFormat value={shipCountry.cost} placeholder="0.00" prefix={"$"} decimalScale={2} thousandSeparator={true} onKeyPress={e => this.handleKeyPress(e)} onValueChange={e => this.handleShippingChange(shipCountry.country, e)} />
											</div>
										);
									})}
								</div>

								<div className="floated-field-container">
									<div className="form-field half-field">
										<label>Order Prefix</label>

										{updateErrors.order_prefix && <div className="error msg_animate">{updateErrors.order_prefix}</div>}
										<input type="text" id="order_prefix" value={this.state.data.order_prefix} maxLength="4" onKeyPress={e => this.handleKeyPress(e)} onChange={event => this.handleInputChange(event)} />
									</div>

									<div className="form-field half-field">
										<label>HST Number</label>

										{updateErrors.hst_registration_number && <div className="error msg_animate">{updateErrors.hst_registration_number}</div>}
										<input type="text" id="order_prefix" value={this.state.data.hst_registration_number} maxLength="50" onKeyPress={e => this.handleKeyPress(e)} onChange={event => this.handleInputChange(event)} />
									</div>
								</div>

								{locationsError ? (
									<div className="error top-margin">{locationsError}</div>
								) : locationsLoading ? (
									<div className="pt2 pb2">
										<Loader />
									</div>
								) : (
									<div className="floated-field-container">
										<div className="form-field half-field">
											<label htmlFor="country">Default Tax Country:</label>

											{!!updateErrors.default_country && <div className="error msg_animate">{updateErrors.default_country}</div>}

											<Select name={`default_country`} placeholder="Country" value={this.state.data.default_country} onChange={selection => this.updateSelectedCountry(selection, "default_country")} clearable={false} valueKey="id" labelKey="title" options={countries} />
										</div>

										<div className="form-field half-field">
											<label htmlFor="province">Default Tax Province:</label>

											{!!updateErrors.default_tax_province && <div className="error msg_animate">{updateErrors.default_tax_province}</div>}

											<Select name={`default_tax_province`} placeholder={this.state.data.country === "CA" ? "Province" : "State"} value={this.state.data.default_tax_province} onChange={selection => this.updateSelectedProvince(selection, "default_tax_province")} clearable={false} valueKey="abbreviation" labelKey="name" options={provinces} />
										</div>
									</div>
								)}
							</div>

							<div className="fieldset">
								<label className="title-label">Location Information:</label>

								<div className="form-field">
									<label>Company Name</label>

									{!!updateErrors.company && <div className="error msg_animate">{updateErrors.company}</div>}
									<input type="text" id="company" value={this.state.data.company} maxLength="255" onKeyPress={e => this.handleKeyPress(e)} onChange={event => this.handleInputChange(event)} />
								</div>

								<div className="form-field">
									<label>Address</label>

									{!!updateErrors.address && <div className="error msg_animate">{updateErrors.address}</div>}
									<input type="text" id="address" value={this.state.data.address} maxLength="255" onKeyPress={e => this.handleKeyPress(e)} onChange={event => this.handleInputChange(event)} />
								</div>

								<div className="floated-field-container">
									<div className="form-field half-field">
										<label>City</label>

										{!!updateErrors.city && <div className="error msg_animate">{updateErrors.city}</div>}
										<input type="text" id="city" value={this.state.data.city} maxLength="255" onKeyPress={e => this.handleKeyPress(e)} onChange={event => this.handleInputChange(event)} />
									</div>

									<div className="form-field half-field">
										<label>Postal</label>

										{!!updateErrors.postal && <div className="error msg_animate">{updateErrors.postal}</div>}
										<input type="text" id="postal" value={this.state.data.postal} maxLength="9" onKeyPress={e => this.handleKeyPress(e)} onChange={event => this.handleInputChange(event)} />
									</div>
								</div>

								{locationsError ? (
									<div className="error top-margin">{locationsError}</div>
								) : locationsLoading ? (
									<div className="pt2 pb2">
										<Loader />
									</div>
								) : (
									<div className="floated-field-container">
										<div className="form-field half-field">
											<label htmlFor="country">Country:</label>

											{!!updateErrors.country && <div className="error msg_animate">{updateErrors.country}</div>}

											<Select name={`country`} placeholder="Country" value={this.state.data.country} onChange={selection => this.updateSelectedCountry(selection, "country")} clearable={false} valueKey="id" labelKey="title" options={countries} />
										</div>

										<div className="form-field half-field">
											<label htmlFor="province">Province:</label>

											{!!updateErrors.location_province && <div className="error msg_animate">{updateErrors.location_province}</div>}

											<Select name={`province`} placeholder={this.state.data.country === "CA" ? "Province" : "State"} value={this.state.data.province} onChange={selection => this.updateSelectedProvince(selection, "province")} clearable={false} valueKey="abbreviation" labelKey="name" options={provinces} />
										</div>
									</div>
								)}

								<div className="floated-field-container">
									<div className="form-field half-field">
										<label htmlFor="phone">Phone:</label>

										{!!updateErrors.phone && <div className="error msg_animate">{updateErrors.phone}</div>}
										<NumberFormat value={this.state.data.phone} format="### ### ####" mask="_" placeholder="Phone number" onKeyPress={e => this.handleKeyPress(e)} onValueChange={e => this.handleNumberChange("phone", e)} />
									</div>
								</div>
							</div>

							{/* CHARITY DONATIONS */}
							<div className="fieldset">
								<label className="title-label">Donation Box:</label>
								<div style={{display: 'flex', alignItems: 'center'}}>
									<div className="floated-field-container">
										<div className="form-field auto-width-field" style={{marginRight: '2em'}}>
											<div className="custom-label checkbox-label no-bottom-margin">
												<input type="hidden" id="id" value={this.state.charity.id}></input>
												<input type="checkbox" id="active" checked={this.state.charity.active} onChange={e => this.handleCharityActive()} />
												<label htmlFor={`active`}>Active</label>
											</div>
										</div>
									</div>
									<input style={{marginRight: '2em', width: '25em'}} type="text" id="charity" placeholder="Enter charity name" value={this.state.charity.charity} maxLength="255" onKeyPress={e => this.handleCharityChange(e)} onChange={event => this.handleCharityChange(event)} />
									<input style={{width: '100%'}} type="text" id="message" placeholder="Enter charity message (or leave blank)" value={this.state.charity.message} maxLength="500" onKeyPress={e => this.handleCharityChange(e)} onChange={event => this.handleCharityChange(event)} />
								</div>
							</div>

							{/* SIMILAR ITEM OPTIONS */}
							<div className="fieldset">
								<label className="title-label">Similar Product Type:</label>
								<div className="floated-field-container">
									{this.state.similar_product_types.map((product, i) => {
										return (
											<div key={i} className="form-field auto-width-field">
												<div className="ajax-error" data-hbs-id="similar_product_types_{{id}}" />
												<div className="custom-label checkbox-label no-bottom-margin">
													<input type="radio" id={`similar_product_types_${product.id}`} value={product.id} checked={product.id === parseInt(this.state.data.similar_product_type, 10)} onChange={e => this.handleRadioClick(e, "similar_product_type")} />
													<label htmlFor={`similar_product_types_${product.id}`}>{product.title}</label>
												</div>
											</div>
										);
									})}
								</div>
							</div>

							{/* IMAGES/LOGOS */}
							<div className="fieldset">
								<label className="title-label">Logo:</label>

								<div className="form-field">
									<ImageUploader loading={updateLoading} clear={!!updateSuccess} required={false} type={"logo"} uploadAssetType={"logo"} addPromise={promise => promiseCollection.push(promise)} handleExistingImageRemoval={index => this.removeExistingImage("logo")} initialImages={!!this.state.initialLogo ? [this.state.initialLogo] : []} imageProperty={"img"} assetIndex={0} error={updateErrors.logo} />
								</div>
							</div>

							<div className="fieldset">
								<label className="title-label">No Product Image:</label>

								<div className="form-field">
									<ImageUploader loading={updateLoading} clear={!!updateSuccess} required={false} type={"no_product_img"} uploadAssetType={"no_product_img"} addPromise={promise => promiseCollection.push(promise)} handleExistingImageRemoval={index => this.removeExistingImage(0, index)} initialImages={!!this.state.initialNoProductImg ? [this.state.initialNoProductImg] : []} imageProperty={"img"} assetIndex={0} error={updateErrors.no_product_img} />
								</div>
							</div>

							<div className="fieldset">
								<div className="btn_container">
									{updateSuccess && <div className="success msg_animate">{updateSuccess}</div>}
									{updateErrors.general && <div className="error msg_animate" dangerouslySetInnerHTML={{ __html: sanitizeHtml(updateErrors.general) }} />}
									<button className={"btn submit-btn" + (updateLoading ? " loading" : "")} onClick={() => this.handleSubmit()} disabled={updateLoading}>
										<span>Update</span>
									</button>
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		user: state.user.admin,
		countries: state.locations.countries,
		default_country: state.locations.default_country,
		provinces: state.locations.provinces,
		locationsLoading: state.locations.isLoading,
		locationsError: state.locations.error
	};
};

export default connect(mapStateToProps, { addRoute, userTokenUpdate, setpageTitle, getSiteInfo, getLocations, getProvinces })(AdminCartSettings);



// WEBPACK FOOTER //
// ./src/components/admin/AdminCartSettings.js